"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactSharedUiNext = require("@eon-funke/react-shared-ui-next");
var _ciamAuthWebClientLib = require("@eon-funke/ciam-auth-web-client-lib");
var _Stepbox = _interopRequireDefault(require("../../components/Stepbox/Stepbox"));
var _LinkExpired = _interopRequireDefault(require("../../components/LinkExpired/LinkExpired"));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2.default)(o), (0, _possibleConstructorReturn2.default)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2.default)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var BASE_CLASS = 'register-confirmation';
var ChangeEmailConfirmation = /*#__PURE__*/function (_React$Component) {
  function ChangeEmailConfirmation() {
    (0, _classCallCheck2.default)(this, ChangeEmailConfirmation);
    return _callSuper(this, ChangeEmailConfirmation, arguments);
  }
  (0, _inherits2.default)(ChangeEmailConfirmation, _React$Component);
  return (0, _createClass2.default)(ChangeEmailConfirmation, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var isLoggedIn = _ciamAuthWebClientLib.SessionHandler.isUserLoggedIn(_ciamAuthWebClientLib.loginTypes.cscn) || _ciamAuthWebClientLib.SessionHandler.isUserLoggedIn(_ciamAuthWebClientLib.loginTypes.callCenter);
      if (isLoggedIn) {
        _ciamAuthWebClientLib.SessionHandler.destroySession(true, window.location.href);
      }
    }
  }, {
    key: "expired",
    value: function expired() {
      return /*#__PURE__*/_react.default.createElement(_LinkExpired.default, {
        title: this.props.expired.title,
        subtitle: this.props.expired.subtitle,
        button: {
          version: this.props.loginButtonVersion,
          redirectUrl: _ciamAuthWebClientLib.SessionHandler.generateCiamLoginUrl(),
          label: this.props.loginButtonLabel
        }
      });
    }
  }, {
    key: "occupied",
    value: function occupied() {
      return /*#__PURE__*/_react.default.createElement(_LinkExpired.default, {
        title: this.props.occupied.title,
        subtitle: this.props.occupied.subtitle,
        button: {
          version: this.props.loginButtonVersion,
          redirectUrl: _ciamAuthWebClientLib.SessionHandler.generateCiamLoginUrl(),
          label: this.props.loginButtonLabel
        }
      });
    }
  }, {
    key: "success",
    value: function success() {
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "col-xs-12 ".concat(BASE_CLASS, "-head")
      }, /*#__PURE__*/_react.default.createElement("h2", null, this.props.success.title), /*#__PURE__*/_react.default.createElement("p", null, this.props.success.text), /*#__PURE__*/_react.default.createElement("p", {
        className: "".concat(BASE_CLASS, "-subtitle")
      }, this.props.success.subtitle));
    }
  }, {
    key: "render",
    value: function render() {
      var occupied = window.location.hash === '#occupied';
      var expired = window.location.hash === '#expired';
      var emailConfirmed = !occupied && !expired;
      var steps = [{
        name: 'Schritt',
        title: this.props.mailSentTitle,
        desc: this.props.mailSentDescription,
        active: false,
        success: true,
        icon: /*#__PURE__*/_react.default.createElement(_reactSharedUiNext.Icon, {
          size: "54",
          glyph: "icon_mail-2_54x54"
        })
      }, {
        name: 'Schritt',
        title: this.props.loginTitle,
        desc: this.props.loginDescription,
        active: true,
        success: false,
        icon: /*#__PURE__*/_react.default.createElement(_reactSharedUiNext.Icon, {
          size: "54",
          glyph: "icon_user-2_54x54"
        }),
        button: {
          text: this.props.loginButtonLabel,
          version: this.props.loginButtonVersion,
          onClick: function onClick() {
            window.location.replace(_ciamAuthWebClientLib.SessionHandler.generateCiamLoginUrl());
          }
        }
      }];
      return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("div", {
        className: "row"
      }, emailConfirmed && this.success(), occupied && this.occupied(), expired && this.expired()), emailConfirmed && /*#__PURE__*/_react.default.createElement(_Stepbox.default, {
        steps: steps
      }));
    }
  }]);
}(_react.default.Component);
ChangeEmailConfirmation.propTypes = {
  expired: _propTypes.default.shape({
    title: _propTypes.default.string,
    subtitle: _propTypes.default.string,
    text: _propTypes.default.string
  }).isRequired,
  occupied: _propTypes.default.shape({
    title: _propTypes.default.string,
    subtitle: _propTypes.default.string,
    text: _propTypes.default.string
  }).isRequired,
  success: _propTypes.default.shape({
    title: _propTypes.default.string,
    subtitle: _propTypes.default.string,
    text: _propTypes.default.string,
    step: _propTypes.default.string
  }).isRequired,
  mailSentTitle: _propTypes.default.string,
  mailSentDescription: _propTypes.default.string,
  loginTitle: _propTypes.default.string,
  loginDescription: _propTypes.default.string,
  loginButtonLabel: _propTypes.default.string,
  loginButtonVersion: _propTypes.default.string,
  errorMessages: _propTypes.default.shape({
    expired: _propTypes.default.string
  }).isRequired
};
var _default = exports.default = ChangeEmailConfirmation;